export const GENERAL_REGISTRATION_SHOW = "GENERAL_REGISTRATION_SHOW";
export const GENERAL_REGISTRATION_HIDE = "GENERAL_REGISTRATION_HIDE";

export const GENERAL_REGISTRATION_STATUS = 'GENERAL_REGISTRATION_STATUS'
